<div class="header-bar">
  <div class="search-container">
    <input-component
      class="search"
      [iconType]="'icon-search'"
      [clearIcon]="'icon-close'"
      [placeholder]="searchPlaceholder | translate"
      [value]="searchText"
      (onChange)="onSearchChange($event)"
    >
    </input-component>
  </div>

  @if (showFilters || filters?.length > 0) {
    <filter-panel
      [filters]="filters"
      (applyFilters)="applyFilters($event)"
      (filtersCounter)="filtersCountChange($event)"
    ></filter-panel>
  }

  <button
    class="x_btn x_sm x_primary"
    [hidden]="refreshBtn.hidden"
    (click)="onRefresh()"
  >
    {{ refreshBtn?.caption | translate }}
  </button>

  <button class="x_btn x_sm x_primary" (click)="onCreateNew()">
    {{ addBtn?.caption | translate }}
  </button>
</div>
